<template>
  <div class="c-app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div :class="isComponent ? 'col-md-12' : 'col-md-4'">
          <div :class="isComponent ? 'py-4' : 'p-4'">
            <form class="text-center">
              <img
                class="mb-4 rounded-circle"
                src="/img/logo.jpg"
                alt=""
                height="72"
              />
              <p class="text-muted small">
                Login with your <b>ScanCom Portal</b> account
              </p>
              <input
                v-model="model.email"
                placeholder="Email. Ex. user@scancom.net"
                autocomplete="email"
                type="text"
                class="form-control"
                autofocus
              />

              <input
                placeholder="Password"
                type="password"
                autocomplete="curent-password"
                v-model="model.password"
                class="form-control mt-2"
                @keyup.enter="login"
              />
              <div class="row mt-2">
                <div class="col-12">
                  <div class="text-center" v-if="loading">
                    <div class="spinner-border text-info" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary w-100"
                    v-else
                    @click="login"
                  >
                    Login
                  </button>
                  <p style="text-align: right !important">
                    <router-link :to="{ name: 'ForgotPassword' }"
                      >Forgot Password ?</router-link
                    >
                  </p>
                </div>
              </div>
              <div
                v-if="model.email && !model.email.includes('@')"
                class="row mt-2"
              >
                <span class="small" style="color: orange">
                  <i class="fa fa-exclamation-triangle"></i>
                  If you are not a Guest user. Please remember to fill your full
                  email address.
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isComponent"],
  name: "Login",
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
      loading: false,
    };
  },
  computed: {
    returnUrl() {
      return this.$route.query.returnUrl;
    },
    authUser: function () {
      return this.$user.getters.authUser;
    },
  },
  mounted() {
    document.title = "ScanCom Portal";
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      if (this.authUser && this.returnUrl && this.returnUrl.includes("http")) {
        this.$user.dispatch("logout");
      }
    },

    async login() {
      this.loading = true;
      try {
        let email = this.model.email;
        let password = this.model.password;
        let resp = await this.$user.dispatch("login", {
          UserName: email,
          Password: password,
        });

        if (resp.data.status == this.$const.RESPONSE_TYPES.Success) {
          //this.$router.push(this.returnUrl ? this.returnUrl : "/");
          if (this.isComponent) {
            this.$emit("success");
          } else {
            let href =
              this.returnUrl && this.returnUrl != "/"
                ? this.returnUrl
                : "welcome";
            location.href = href;
          }
        } else if (resp.data.message) {
          this.$swal({ text: this.$const.MESSAGE[resp.data.message] });
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          text: error.message,
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

<style lang="scss" scoped>
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;

  .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }

  input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}

.btn-block {
  display: block;
  width: 100%;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  border: 0;
}

body {
  background-color: #f5f5f5;
}
</style>
